import { PRESET_CUE_MESSAGE_PARAM } from './preset-cue-message';

const MAX_POST_SIGN_IN_TARGET_LENGTH = 1024;

/**
 * Validates that a return_to value is a safe relative path.
 * Rejects external URLs, protocol-relative URLs (//evil.com), and
 * backslash bypasses (\/evil.com — some browsers normalize to //evil.com).
 *
 * Uses URL-parse as the canonical approach: any host injection resolves
 * to a non-example.com hostname and is rejected.
 */
export function isSafeRelativePath(raw: string): boolean {
  if (!raw.startsWith('/') || raw.startsWith('//')) {
    return false;
  }
  try {
    const url = new URL(raw, 'https://example.com');
    return url.hostname === 'example.com';
  } catch {
    return false;
  }
}

export function postSignInTarget(raw: string | null): string | null {
  if (
    !raw ||
    raw.length > MAX_POST_SIGN_IN_TARGET_LENGTH ||
    !isSafeRelativePath(raw)
  ) {
    return null;
  }
  const url = new URL(raw, 'https://example.com');
  if (
    // The bare root only resolves the slug again; `/{orgSlug}` is direct.
    url.pathname === '/' ||
    url.pathname === '/sign-in' ||
    url.pathname.startsWith('/sign-in/') ||
    url.pathname.startsWith('/api/')
  ) {
    return null;
  }
  // A sign-in return opens a page; it must never send a message as the user.
  url.searchParams.delete(PRESET_CUE_MESSAGE_PARAM);
  const target = url.pathname + url.search;
  return isSafeRelativePath(target) ? target : null;
}
